import { Component, Vue, namespace } from 'nuxt-property-decorator';
import { namespace as userAuthStore, actionType, ITokensParams } from '../store/modules/auth-store';

const UserAuthStore = namespace(userAuthStore);

@Component
export default class UserAuthMixin extends Vue {
	@UserAuthStore.Action(actionType.SET_TOKEN) setToken!: (tokens: ITokensParams) => void;
}
